export default __webpack_public_path__ + "static/media/VC.5b31e92e.ico";